import { Component, OnInit, Optional, Inject, Input } from '@angular/core';
import { IAppDataStore } from '@pershing/pershing-core';
import { MatDialogConfig, MatDialog } from '@angular/material/dialog';
import { ExchangeAgreementConfirmLaterDialogComponent } from '../ExchangeAgreementConfirmlaterDialog/exchange-agreement-confirmlater-dialog.component';
import { HttpErrorResponse } from '@angular/common/http';
import { TradingService, TradingEntitlements, Account } from '@pershing/trading-common';
@Component({
    selector: 'exchange-agreement-opra',
    templateUrl: './exchange-agreement-opra.component.html'
})
export class ExchangeAgreementOPRAComponent implements OnInit {

    @Input() platform: string;
    @Input() public tradingEntitlements: TradingEntitlements = null;

    isbuttonDisabled = true;
    data: string;
    jsonDataSubs: any;
    nonProfData: any;
    nasdaqData: any;
    oPraData: any;
    npsdData: any;
    profData: any;
    serverError: boolean = false;
    deviceType: string = 'desktop';
    constructor(private dialog: MatDialog,
                private tradingService: TradingService, private appDataStore: IAppDataStore, @Optional() @Inject('AppSettings') appSettings: any) {
        // this.translationService.addTranslationFolder('@pershing/nxi-ng-miscellaneous', 'node_modules/@pershing/nxi-ng-miscellaneous/src');
        if (!!appSettings.deviceType) {
            this.deviceType = appSettings.deviceType;
        }
    }
    ngOnInit() {
        console.log('Exchange Agreement Overview');
        this.getExchangeData();
        this.jsonDataSubs = this.appDataStore.get('NASDAQDATA');
    }
    showCancelDialog(): void {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = false;
        dialogConfig.minWidth = '250px';
        dialogConfig.disableClose = true;
        this.dialog.open(ExchangeAgreementConfirmLaterDialogComponent, dialogConfig);
    }
    getExchangeData() {

        this.tradingService.onAccountListSubject$.subscribe(accounts => {
            // pick the primary account
            let accountToUse = null as Account;
            for (let account of accounts ) {
                if (account.primaryAcct) {
                    accountToUse = account;
                    break;
                }
            }

            // use the first account if none of the account is primary.
            // ideally this should never be executed.
            if (accountToUse === null) {
                accountToUse = accounts[0];
            }
            // this reg edit doesn't work for all the data.
            // this.data = accountToUse.acctAddress.replace(/\b\s{2,}\b/g, '<br/>');
            this.data = accountToUse.acctAddress;

        });

        // get all the accounts and look for the primary account's address.
        // this data will be fetched from the service's cache
        this.tradingService.getAccounts(this.platform);
    }
    Confirmation() {
        console.log('NONPROFDATA', this.appDataStore.get('NONPROFDATA'));
        console.log('NASDAQDATA', this.appDataStore.get('NASDAQDATA'));
        console.log('NPSDDATA', this.appDataStore.get('NPSDDATA'));
        console.log('PROFDATA', this.appDataStore.get('PROFDATA'));
        if (this.appDataStore.get('NONPROFDATA') === undefined || this.appDataStore.get('NONPROFDATA') === '') {
            this.nonProfData = {};
        } else {
            this.nonProfData = this.appDataStore.get('NONPROFDATA');
        }
        this.nasdaqData = this.appDataStore.get('NASDAQDATA');
        this.oPraData = { agreementIdThree: '03' };
        this.npsdData = this.appDataStore.get('NPSDDATA');
        this.profData = this.appDataStore.get('PROFDATA');
        this.tradingService.opraData(this.platform, this.nonProfData, this.nasdaqData, this.oPraData, this.npsdData, this.profData).subscribe(
            data => {
                // this.router.navigate(['/nxi/exchangeagreementconfirm'], { queryParamsHandling: 'preserve' });
                // document.dispatchEvent(new CustomEvent('portal.browserTitleValue', {
                //     detail: {
                //         titleValue: 'exchangeagreementconfirm'
                //     }
                // }));
                this.tradingService.setExchangeAgreementDialogState('updateEntitlements');
                console.log('Response Data', data);
                this.appDataStore.put('RESPONSE', data);
                this.serverError = false;
                this.tradingService.setExchangeAgreementDialogState('exchangeagreementconfirm');
            },
            (err: HttpErrorResponse) => {
                this.serverError = true;
            }
        );
    }
    enableSubmit(event: any) {
        console.log(event.checked);
        if (event.checked) {
            console.log('inside true');
            this.isbuttonDisabled = false;
        } else {
            this.isbuttonDisabled = true;
            console.log('inside false');
        }
    }
}
